export default async function loadAsyncComponent(asyncRender) {
  if (!asyncRender.__result__) {
    asyncRender.__result__ = await asyncRender();
  }
  return asyncRender.__result__;
}
